import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import {Message} from 'element-ui'

const pageLogin = () => import('../pages/login/pageLogin')
const pageIndex = () => import('../pages/pageIndex')
const pageNotFound = () => import('../pages/pageNotFound')

const pageAccountList = () => import('../pages/account/pageList')
const pageAccountInfo = () => import('../pages/account/pageInfo')

const pageUserList = () => import('../pages/user/pageList')
const pageUserForm = () => import('../pages/user/pageForm')
const pageUserInfo = () => import('../pages/user/pageInfo')

const pageProductList = () => import('../pages/product/pageList')
const pageProductForm = () => import('../pages/product/pageForm')

const pageProFuncList = () => import('../pages/product/func/pageList')
const pageProFuncForm = () => import('../pages/product/func/pageForm')

const pagePackList = () => import('../pages/pack/pageList')
const pagePackForm = () => import('../pages/pack/pageForm')

const pageDeviceList = () => import('../pages/device/pageList')
const pageDeviceInfo = () => import('../pages/device/pageInfo')
const pageDanaDeviceList = () => import('../pages/device/pageDanaList')
const pageDanaFacilityList = () => import('../pages/device/pageDanaFacility')
const pageNooieFacilityList = () => import('../pages/device/pageNooieFacility')

const pageFactoryList = () => import('../pages/device/pageFactoryList')
const pageFactoryRecordList = () => import('../pages/device/pageFactoryRecordList')

const pageSnFactoryList = () => import('../pages/device/sn/pageSnFactoryList')
const pageSnProductList = () => import('../pages/device/sn/pageSnProductList')
const pageSnProductForm = () => import('../pages/device/sn/pageSnProductForm')

const pageVersionHardList = () => import('../pages/version/pageList')
const pageVersionHardForm = () => import('../pages/version/pageForm')
const pageVersionSoftList = () => import('../pages/version/pageSoftList')
const pageVersionSoftForm = () => import('../pages/version/pageSoftForm')

const pageAppList = () => import('../pages/app/pageList')
const pageAppForm = () => import('../pages/app/pageForm')
const pageJpushList = () => import('../pages/app/jpush/pageList')
const pageJpushForm = () => import('../pages/app/jpush/pageForm')
const pageFcmList = () => import('../pages/app/fcm/pageList')
const pageFcmForm = () => import('../pages/app/fcm/pageForm')
const pageApnsList = () => import('../pages/app/apns/pageList')
const pageApnsForm = () => import('../pages/app/apns/pageForm')
const pageCertList = () => import('../pages/app/cert/pageList')
const pageCertForm = () => import('../pages/app/cert/pageForm')
const pageGetuiList = () => import('../pages/app/getui/pageList')
const pageGetuiForm = () => import('../pages/app/getui/pageForm')
const pageUpushList = () => import('../pages/app/upush/pageList')
const pageUpushForm = () => import('../pages/app/upush/pageForm')

const pageOrderList = () => import('../pages/order/pageList')

const pageMsgList = () => import('../pages/msg/pageMsgList')
const pageMsgDeviceList = () => import('../pages/msg/pageMsgDeviceList')
const pageMsgOrderList = () => import('../pages/msg/pageMsgOrderList')
const pageMsgShareList = () => import('../pages/msg/pageMsgShareList')
const pageShareList = () => import('../pages/msg/pageShareList')

// const pageFeedbackList = () => import('../pages/feedback/pageList')
// const pageFeedbackInfo = () => import('../pages/feedback/pageInfo')
const pageFeedbackTypeList = () => import('../pages/feedback/pageTypeList')

const pageLogList = () => import('../pages/log/pageList')
const pageLogInfo = () => import('../pages/log/pageInfo')
const pageMongoLogList = () => import('../pages/log/pageMongoLogList')

const pageAdminUserList = () => import('../pages/admin/user/pageList')
const pageAdminUserForm = () => import('../pages/admin/user/pageForm')
const pageAdminRoleList = () => import('../pages/admin/role/pageList')
const pageAdminRoleForm = () => import('../pages/admin/role/pageForm')
const pageAdminMenuList = () => import('../pages/admin/menu/pageList')
const pageAdminMenuForm = () => import('../pages/admin/menu/pageForm')
const pageAdminFuncList = () => import('../pages/admin/func/pageList')
const pageAdminFuncForm = () => import('../pages/admin/func/pageForm')
const pageAdminLogList = () => import('../pages/admin/log/pageList')
const pageAdminLinkList = () => import('../pages/admin/link/pageList')
const pageAdminLinkForm = () => import('../pages/admin/link/pageForm')

const pageStatisticsUserDistributed = () => import('../pages/statistics/pageUser')
const pageStatisticsDeviceDistributed = () => import('../pages/statistics/pageDevice')
const pageStatisticsUser = () => import('../pages/statistics/user/index')
const pageStatisticsShare = () => import('../pages/statistics/share/index')
const pageStatisticsOrder = () => import('../pages/statistics/order/index')
const pageStatisticsAppOpen = () => import('../pages/statistics/data/appOpenList')
const pageStatisticsDevice = () => import('../pages/statistics/device/index')
const pageStatisticsNum = () => import('../pages/statistics/data/numStatisticsList')
const pageStatisticsSale = () => import('../pages/statistics/sale/index')
const pageSaleList = () => import('../pages/statistics/sale/list')

const pageServerBaseList = () => import('../pages/server/base/pageList')
const pageServerBaseForm = () => import('../pages/server/base/pageForm')
const pageServerAccountList = () => import('../pages/server/account/pageList')
const pageServerAccountForm = () => import('../pages/server/account/pageForm')

const pageSyncList = () => import('../pages/sync/pageList')
const pageSyncInfo = () => import('../pages/sync/pageInfo')
const pageSyncType = () => import('../pages/sync/pageType')

const pageCountryList = () => import('../pages/country/pageList')
const pageCountryForm = () => import('../pages/country/pageForm')

const pageAdminVersionList = () => import('../pages/admin/version/pageList')
const pageAdminVersionForm = () => import('../pages/admin/version/pageForm')

Vue.use(Router)

// 刷新网页重新获取store状态缓存数据
store.commit('switch_login')

const routerArr = [
    {
        path: '/',
        redirect: '/account'
    },
    {
        path: '/login',
        component: pageLogin
    },
    {
        path: '/user',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageUserList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'form',
                component: pageUserForm,
                meta: {isLogin: true}
            },
            {
                path: 'info/:id',
                component: pageUserInfo,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '/account',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageAccountList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'info/:id',
                component: pageAccountInfo,
                meta: {isLogin: true}
            },
            {
                path: 'app-open',
                component: pageStatisticsAppOpen,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '/product',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageProductList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'form/:id',
                component: pageProductForm,
                meta: {isLogin: true}
            },
            {
                path: 'pack',
                component: pagePackList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'pack/form/:id',
                component: pagePackForm,
                meta: {isLogin: true}
            },
            {
                path: 'func',
                component: pageProFuncList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'func/form/:id',
                component: pageProFuncForm,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '/device',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageFactoryList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: '/device',
                component: pageDeviceList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'info',
                component: pageDeviceInfo,
                meta: {isLogin: true}
            },
            {
                path: 'dana',
                component: pageDanaDeviceList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'factory',
                component: pageFactoryList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'record',
                component: pageFactoryRecordList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'dana/facility',
                component: pageDanaFacilityList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'nooie/facility',
                component: pageNooieFacilityList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'sn/factory',
                component: pageSnFactoryList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'sn/product',
                component: pageSnProductList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'sn/product/form/:id',
                component: pageSnProductForm,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '/app',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageAppList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'form/:id',
                component: pageAppForm,
                meta: {isLogin: true}
            },
            {
                path: 'jpush',
                component: pageJpushList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'jpush/form/:id',
                component: pageJpushForm,
                meta: {isLogin: true}
            },
            {
                path: 'fcm',
                component: pageFcmList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'fcm/form/:id',
                component: pageFcmForm,
                meta: {isLogin: true}
            },
            {
                path: 'apns',
                component: pageApnsList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'apns/form/:id',
                component: pageApnsForm,
                meta: {isLogin: true}
            },
            {
                path: 'getui',
                component: pageGetuiList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'getui/form/:id',
                component: pageGetuiForm,
                meta: {isLogin: true}
            },
            {
                path: 'cert',
                component: pageCertList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'cert/form/:id',
                component: pageCertForm,
                meta: {isLogin: true}
            },
            {
                path: 'upush',
                component: pageUpushList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'upush/form/:id',
                component: pageUpushForm,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '/version',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageVersionHardList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'form/:id',
                component: pageVersionHardForm,
                meta: {isLogin: true}
            },
            {
                path: 'soft',
                component: pageVersionSoftList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'soft/form/:id',
                component: pageVersionSoftForm,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '/order',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageOrderList,
                meta: {isLogin: true, keepAlive: true}
            }
        ]
    },
    {
        path: '/msg',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageMsgList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'device',
                component: pageMsgDeviceList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'order',
                component: pageMsgOrderList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'share',
                component: pageMsgShareList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'share/data',
                component: pageShareList,
                meta: {isLogin: true, keepAlive: true}
            }
        ]
    },
    {
        path: '/feedback',
        component: pageIndex,
        children: [
            // {
            //   path: '/',
            //   component: pageFeedbackList,
            //   meta: {isLogin: true, keepAlive: true}
            // },
            {
                path: '/',
                component: pageFeedbackTypeList,
                meta: {isLogin: true, keepAlive: true}
            }
            // {
            //   path: 'info/:id',
            //   component: pageFeedbackInfo,
            //   meta: {isLogin: true}
            // },
            // {
            //   path: 'type',
            //   component: pageFeedbackTypeList,
            //   meta: {isLogin: true, keepAlive: true}
            // }
        ]
    },
    {
        path: '/log',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageLogList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'info/:id',
                component: pageLogInfo,
                meta: {isLogin: true}
            },
            {
                path: 'mlog',
                component: pageMongoLogList,
                meta: {isLogin: true, keepAlive: true}
            }
        ]
    },
    {
        path: '/sync',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageSyncList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'info/:id',
                component: pageSyncInfo,
                meta: {isLogin: true}
            },
            {
                path: 'type',
                component: pageSyncType,
                meta: {isLogin: true, keepAlive: true}
            }
        ]
    },
    {
        path: '/web',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageAdminUserList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'adminer/form/:id',
                component: pageAdminUserForm,
                meta: {isLogin: true}
            },
            {
                path: 'role',
                component: pageAdminRoleList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'role/form/:id',
                component: pageAdminRoleForm,
                meta: {isLogin: true}
            },
            {
                path: 'menu',
                component: pageAdminMenuList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'menu/form/:id',
                component: pageAdminMenuForm,
                meta: {isLogin: true}
            },
            {
                path: 'func',
                component: pageAdminFuncList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'func/form/:id',
                component: pageAdminFuncForm,
                meta: {isLogin: true}
            },
            {
                path: 'link',
                component: pageAdminLinkList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'link/form',
                component: pageAdminLinkForm,
                meta: {isLogin: true}
            },
            {
                path: 'log',
                component: pageAdminLogList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'version',
                component: pageAdminVersionList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'version/form/:id',
                component: pageAdminVersionForm,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '/statistics',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageStatisticsUser,
                meta: {isLogin: true}
            },
            {
                path: 'share',
                component: pageStatisticsShare,
                meta: {isLogin: true}
            },
            {
                path: 'order',
                component: pageStatisticsOrder,
                meta: {isLogin: true}
            },
            {
                path: 'device',
                component: pageStatisticsDevice,
                meta: {isLogin: true}
            },
            {
                path: 'user-distributed',
                component: pageStatisticsUserDistributed,
                meta: {isLogin: true}
            },
            {
                path: 'device-distributed',
                component: pageStatisticsDeviceDistributed,
                meta: {isLogin: true}
            },
            {
                path: 'num',
                component: pageStatisticsNum,
                meta: {isLogin: true}
            },
            {
                path: 'sale',
                component: pageStatisticsSale,
                meta: {isLogin: true}
            },
            {
                path: 'sale/list',
                component: pageSaleList,
                meta: {isLogin: true}
            },
            {
                path: 'country',
                component: pageCountryList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'country/form/:id',
                component: pageCountryForm,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '/server',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageServerBaseList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'form/:id',
                component: pageServerBaseForm,
                meta: {isLogin: true}
            },
            {
                path: 'account',
                component: pageServerAccountList,
                meta: {isLogin: true, keepAlive: true}
            },
            {
                path: 'account/form/:id',
                component: pageServerAccountForm,
                meta: {isLogin: true}
            }
        ]
    },
    {
        path: '*',
        component: pageIndex,
        children: [
            {
                path: '/',
                component: pageNotFound,
                meta: {isLogin: true}
            }
        ]
    }
]

const router = new Router({
    mode: 'history',
    routes: routerArr
})

const rules = {
    '/account/info': 'admin/account/info',

    '/user/info': 'admin/user/info',
    '/user/form': 'admin/user/create',

    '/product/form/0': 'admin/product/create',
    '/product/form': 'admin/product/info',

    '/product/func/form/0': 'admin/pro/func/create',
    '/product/func/form': 'admin/pro/func/info',

    '/product/pack/form/0': 'admin/pack/create',
    '/product/pack/form': 'admin/pack/info',

    '/device/info': 'admin/device/info',

    '/version/form/0': 'admin/version/create',
    '/version/form': 'admin/version/info',
    '/version/soft/form/0': 'admin/version/create',
    '/version/soft/form': 'admin/version/info',

    '/app/form/0': 'admin/app/create',
    '/app/form': 'admin/app/info',
    '/app/jpush/form/0': 'admin/app/jpush/create',
    '/app/jpush/form': 'admin/app/jpush/info',
    '/app/fcm/form/0': 'admin/app/fcm/create',
    '/app/fcm/form': 'admin/app/fcm/info',
    '/app/apns/form/0': 'admin/app/apns/create',
    '/app/apns/form': 'admin/app/apns/info',
    '/app/gegui/form/0': 'admin/app/gegui/create',
    '/app/gegui/form': 'admin/app/gegui/info',
    '/app/upush/form/0': 'admin/app/upush/create',
    '/app/upush/form': 'admin/app/upush/info',

    '/app/cert/form/0': 'admin/file/cert/create',
    '/app/cert/form': 'admin/file/info',

    '/server/form/0': 'admin/server/base/create',
    '/server/form': 'admin/server/base/info',
    '/server/account/form/0': 'admin/server/account/create',
    '/server/account/form': 'admin/server/account/info',

    '/statistics/country/form/0': 'admin/country/create',
    '/statistics/country/form': 'admin/country/info',

    '/feedback/info': 'admin/feedback/info',

    '/web/adminer/form/0': 'admin/admin/add',
    '/web/adminer/form': 'admin/admin/info',
    '/web/role/form/0': 'admin/role/add',
    '/web/role/form': 'admin/role/info',
    '/web/menu/form/0': 'admin/menu/add',
    '/web/menu/form': 'admin/menu/info',
    '/web/func/form/0': 'admin/func/add',
    '/web/func/form': 'admin/func/info',
    '/web/version/form/0': 'admin/version/admin/create',
    '/web/version/form': 'admin/version/admin/info'
}

// 路由前置
router.beforeEach((to, from, next) => {
    if (!to.meta.isLogin) return next()

    if (store.state.login.isLogin) {
        if (localStorage.role === '1') return next()

        // 判断是否具备操作权限
        let path = to.path
        let funs = JSON.parse(localStorage.funs)

        // console.log(path, funs, rules.hasOwnProperty(path), funs.indexOf(rules[path]))
        if (rules.hasOwnProperty(path) && funs.indexOf(rules[path]) === -1) {
            Message('暂无权限')
            return false
        }

        if (!rules.hasOwnProperty(path)) {
            var reg = /\/\d+/g
            var p = path.replace(reg, '')
            // console.log(p, rules.hasOwnProperty(p), funs.indexOf(rules[p]))
            if (rules.hasOwnProperty(p) && funs.indexOf(rules[p]) === -1) {
                Message('暂无权限')
                return false
            }
        }

        // 设置loadState中isLoading状态为true，开始加载
        // if (path.indexOf('statistics') !== -1) {
        //   store.state.load.isLoading = true
        // }

        return next()
    } else {
        return next({path: '/login', query: {redirect: to.fullPath}})
    }
})

// 路由后置
router.afterEach((to, from) => {
    // 设置loadState中isLoading状态为true，开始加载
    store.state.load.isLoading = false
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js